import commonModels from './config/commonModels';
import config from '../config';

const variantSpecificModels =
  config.features.header.variant === 'kraken'
    ? require('./config/krakenModels')
    : require('./config/unityModels');

const models = { ...variantSpecificModels, ...commonModels };

export default models;
